import ReactDOM from "react-dom/client";
import "semantic-ui-css/semantic.min.css";
// import StateContext from "./salesRecipt/context/stateContext";
import StateContext from "./Pages/SaleComponent/salesRecipt/context/stateContext";
import ContextSales from "./Pages/SaleComponent/salesRecord/context/ContextSales";

import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReturnContext from "./Pages/returnComponent/context/ContextReturn";
import { ReturnStateProvider } from "./Pages/returnComponent/ReturnInvoice/context/returnContext";
// import TransferStateContect from "./Transfer Recipt/context/stateContext";
import PurchaseStateContext from "./Pages/PurchaseComponent/purchaseRecipt/context/stateContext";
import PurchaseReportStateContext from "./Pages/PurchaseComponent/purchaseRecord/context/ContextSales";
import TransferStateContect from "./Pages/TransferComponent/Transfer Recipt/context/stateContext";
import TransferReoprtStateContect from "./Pages/TransferComponent/Transfer Record/context/ContextSales";

import TableStateContext from "./Components/tableComponent/tableContext";
import ExpensePaymentStateContext from "./Pages/ExpenseComponent/CashDeposit/context/paymentStateContext";
import ExpenseStateeContext from "./Pages/ExpenseComponent/Expensee/context/stateContext";
// import { HistoryProvider } from "./HistoryContext";
import { Provider as AlertProvider, positions, transitions } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import { HistoryProvider } from "./HistoryContext";
// import "./index.css";
import "./SaasStyling/app.scss";
// import { store } from "./app/store";
import { QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import queryClient from "./actionHooks/queryClient";
import App from "./App";
import NetworkConnection from "./Components/Network/NetworkConnection";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
const options = {
  timeout: 5000,
  position: positions.BOTTOM_CENTER,
  transition: transitions.SCALE,
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>

  <Provider store={store}>
    {/* <PersistGate loading={null} persistor={persistor}> */}
    <ContextSales>
      <StateContext>
        <TransferStateContect>
          <TransferReoprtStateContect>
            <PurchaseStateContext>
              <PurchaseReportStateContext>
                <ExpenseStateeContext>
                  <ExpensePaymentStateContext>
                    <ReturnStateProvider>
                      <TableStateContext>
                        <HistoryProvider>
                          <ReturnContext>
                            <QueryClientProvider client={queryClient}>
                              <AlertProvider
                                template={AlertTemplate}
                                {...options}
                              >
                                {/* <BrowserRouter> */}
                                <NetworkConnection />
                                <App />
                                {/* </BrowserRouter> */}
                              </AlertProvider>
                            </QueryClientProvider>
                          </ReturnContext>
                        </HistoryProvider>
                      </TableStateContext>
                    </ReturnStateProvider>
                  </ExpensePaymentStateContext>
                </ExpenseStateeContext>
              </PurchaseReportStateContext>
            </PurchaseStateContext>
          </TransferReoprtStateContect>
        </TransferStateContect>
      </StateContext>
    </ContextSales>
    <ToastContainer
      position="top-center"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      transition={Slide} // Use Slide component here
    />
    {/* </PersistGate> */}
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
